module.exports = __webpack_public_path__ + "img/tuts-rating-slider-mobile-2.75c03696.png";